import { render, staticRenderFns } from "./BeforeAfter.vue?vue&type=template&id=e519c062&scoped=true"
import script from "./BeforeAfter.vue?vue&type=script&lang=js"
export * from "./BeforeAfter.vue?vue&type=script&lang=js"
import style0 from "./BeforeAfter.vue?vue&type=style&index=0&id=e519c062&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e519c062",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e519c062')) {
      api.createRecord('e519c062', component.options)
    } else {
      api.reload('e519c062', component.options)
    }
    module.hot.accept("./BeforeAfter.vue?vue&type=template&id=e519c062&scoped=true", function () {
      api.rerender('e519c062', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/BeforeAfter.vue"
export default component.exports